import Slider from "react-slick";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CalloutsType } from "../../../models/home/callouts.model";
import { RootState, useAppDispatch } from "../../../redux/store";
import { retrieveCallouts } from "../../../redux/slice/home/callouts.slice";

const CalloutComponent =() => {
  const { data: calloutsData } = useSelector((state: RootState) => state.callouts);
  const [calloutItems, setCalloutItems] = useState([] as CalloutsType[]);
  const [width, setWidth] = useState(window.innerWidth) 

  const xlarge = width > 1310
  const large = width > 1024 && width < 1309
  const medium = width > 641 && width < 1023
  //const small = width <= 640

  let settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: xlarge ? 5 : large ? 3 : medium ? 2 : 1,
    slidesToScroll: xlarge ? 5 : large ? 3 : medium ? 2 : 1,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: false,
    initialSlide: 0
  }

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveCallouts());
  }, [dispatch]);

  useEffect(() => {
    if (calloutsData.callOutItems) {
      setCalloutItems(calloutsData.callOutItems);
    }
  }, [calloutsData]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [ ])


  if (calloutItems === undefined) return <></>;

  return (
    <>

    <div className="page-section brand-texture" id="">
      <div className="container">
        <div className="card-callouts">
          <ul className="blue-circle-dots callouts-slick">
        {
           calloutItems &&  <Slider {...settings}>
            {calloutItems.map((item, index) => {
              return <SimpleCallout key={index} data={item} />;
            })}
            </Slider>
        }
            </ul>
            <p>&nbsp;</p>
            <div className="container" style={{ textAlign: "center", marginTop: 15 }}>
              <Link to="/" style={{ fontWeight: "bold", fontSize: 18 }}>
                Visit the RAPS Homepage{" "}<i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CalloutComponent;

const SimpleCallout = (props: { data: CalloutsType }) => {
  const { data } = props;
  return (<li>
      <div className="card card-icon" style={{ height: 228.688 }}>
        <a href={data.calloutLink}>
          <img alt={data.calloutTitle} src={data.calloutImage} />
        </a>
        <div className="caption">
          <h3>
            <a href={data.calloutLink}>{data.calloutTitle} </a>
          </h3>
          <p>{data.calloutText}</p>
          <a className="btn btn-default" href={data.calloutLink} role="button">
            {data.calloutButtonText}
          </a>
        </div>
      </div>
    </li>
  );
};
